/** EN uses Swedish values until translated. */
export const advisorsTranslationsEn = {
    title: 'Hela sidan ska tas bort',
    columns: {
        name: 'Hela sidan ska tas bort',
        financialAdvisorCount: 'Hela sidan ska tas bort',
        legalAdvisor: 'Hela sidan ska tas bort',
        issuingAgent: 'Hela sidan ska tas bort',
    },
    details: {
        generalAbout: 'Hela sidan ska tas bort',
        advisorFallback: 'Hela sidan ska tas bort',
        placeholderTitle: 'Hela sidan ska tas bort',
        placeholderValue: 'Hela sidan ska tas bort',
        issuesAsAdvisor: 'Hela sidan ska tas bort',
    },
    advisorTypes: {
        financial_advisor: 'Hela sidan ska tas bort',
        legal_advisor: 'Hela sidan ska tas bort',
        issuing_agent: 'Hela sidan ska tas bort',
    },
    summary: {
        financialOnly: 'Hela sidan ska tas bort',
        legalOnly: 'Hela sidan ska tas bort',
        issuingAgentOnly: 'Hela sidan ska tas bort',
        financialAndLegal: 'Hela sidan ska tas bort',
        financialAndIssuingAgent: 'Hela sidan ska tas bort',
        legalAndIssuingAgent: 'Hela sidan ska tas bort',
        allThree: 'Hela sidan ska tas bort',
        default: 'Hela sidan ska tas bort',
    },
}
